import Vue from "vue";
import _ from "lodash";
import VueI18n, { LocaleMessages } from "vue-i18n";
import zhCountryRegionNames from "@/country-region-data/zh-country-region-names";
import enCountryRegionNames from "@/country-region-data/en-country-region-names";

Vue.use(VueI18n);

const CURRENT_LOCALE = localStorage.getItem("tms-h5.lang") || "zh-CN";

const COUNTRY_REGION_NAMES = {
    "en-US": enCountryRegionNames,
    "zh-CN": zhCountryRegionNames
};

function loadLocaleMessages(): LocaleMessages {
    const locales = require.context("./", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    let messages: LocaleMessages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    messages = _.merge(messages, _.get(COUNTRY_REGION_NAMES, CURRENT_LOCALE, {}));
    return messages;
}

export default new VueI18n({
    locale: CURRENT_LOCALE,
    fallbackLocale: "zh-CN",
    silentTranslationWarn: true,
    messages: loadLocaleMessages()
});
